import * as types from '../mutation-types'
// import VueSweetalert2 from 'vue-sweetalert2'
// initial state
const state = {
  lang: 'zh-tw'
}

const getters = {
  lang: state => state.lang
}

// actions
const actions = {
  setLang ({commit}, payload) {
    localStorage.setItem('lang', payload)
    commit(types.SET_LANG, payload)
  }
}

// mutations
const mutations = {
  [types.SET_LANG] (state, payload) {
    state.lang = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
